import {
  LoggedInUserModel,
  UserArrayModel,
  UserModel,
} from "../../models/UserModel";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialUserState: UserArrayModel = {
  all_Users: [],
  particular_User: {
    userId: 0,
    firstName: "",
    lastName: "",
    emailId: "",
    roleId: 0,
    isActive: false,
    loginid: "",
    password: "",
  },
  loggedIn_User: {
    userId: 0,
    fullName: "",
    emailId: "",
    roleId: 0,
    roleName: "",
    bdHeadFullName: "",
    sbgId: 0,
    sbgName: "",
    sbgHeadName: "",
    sbuId: 0,
    sbuName: "",
    sbuHeadName: "",
    csgoId: 0,
    csgoName: "",
    csgoHeadName: "",
    isActive: false,
    loggedIn: undefined,
    isAdmin: false,
    switchRoleId: 0,
  },
  isFetching: false,
};

const userSlice = createSlice({
  name: "User",
  initialState: initialUserState,
  reducers: {
    setUsers(state, action: PayloadAction<UserModel[]>) {
      state.all_Users = action.payload;
    },
    setParticularUser(state, action: PayloadAction<UserModel>) {
      state.particular_User = action.payload;
    },
    setLoggedInUser(state, action: PayloadAction<LoggedInUserModel>) {
      state.loggedIn_User = action.payload;
    },
    logOutUser(state) {
      state.loggedIn_User = initialUserState.loggedIn_User;
    },
    resetParticularUser(state) {
      state.particular_User = initialUserState.particular_User;
    },
    setIsFetching(state, action: PayloadAction<boolean>) {
      state.isFetching = action.payload;
    },
    setIsAdmin(state, action: PayloadAction<{ id: number; status: boolean }>) {
      const { id, status } = action.payload;
      const index = state.all_Users.findIndex((rec) => rec.userId === id);
      state.all_Users[index].isAdmin = status;
    },
    setIsImportantEmailReceiver(state, action: PayloadAction<{ id: number; status: boolean }>) {
      const { id, status } = action.payload;
      const index = state.all_Users.findIndex((rec) => rec.userId === id);
      state.all_Users[index].isImportantEmailReceiver = status;
    },
  },
});

export default userSlice;
